import { useRef } from "react";
import styled from "styled-components";

import COLORS from "components/atoms/colors";

import { InputChange } from "types/Form";
import Action from "types/Action";
import useUpload from "apis/mutations/useUpload";

import imgAdd from "assets/images/common/add.svg";

interface Props {
  image?: string;
  name: string;
  onDispatch: (option: Action["option"]) => void;
}

// 씬 이미지 업로드
const FormImage = ({ name, image, onDispatch }: Props) => {
  const fileRef = useRef<HTMLInputElement>(null);

  const upload = useUpload({
    onSuccess: (url) => onDispatch({ key: "image", value: url }),
  });

  const handleChange = (event: InputChange) => {
    const selectedFiles = event.target.files;
    if (!selectedFiles) return;
    upload(selectedFiles[0]);
  };

  return (
    <Container onClick={() => fileRef.current?.click()} border={!image}>
      <input
        name={name}
        type="file"
        className="hidden"
        ref={fileRef}
        onChange={handleChange}
        accept="image/*"
      />
      {image ? <img src={image} alt="" /> : <img src={imgAdd} alt="" />}
    </Container>
  );
};

const Container = styled.div<{ border: boolean }>`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 148px;
  height: 100px;
  border-radius: 8px;
  background: ${COLORS.white["60%"]};
  border-color: ${COLORS.black["20%"]};
  border-width: ${({ border }) => (border ? "1px" : 0)};
  overflow: hidden;
`;

export default FormImage;
